import { HTMLAttributes } from 'react';
import css from '@styled-system/css';
import { ThemeColors } from 'components/theme';
import { Pseudos } from 'csstype';
import styled from '@emotion/styled';
import { color, ResponsiveValue } from 'styled-system';
import {
  TextColorProps,
  TextAlignProps,
  TextShadowProps,
  TextStyleProps,
} from 'styled-system';
import shouldForwardProp from '@styled-system/should-forward-prop';
import variant from '@styled-system/variant';

const styles = {
  '6': {
    fontSize: 6,
    letterSpacing: '-2.05px',
    lineHeight: '51px',
    fontWeight: 700,
  },
  '5': {
    fontSize: 5,
    letterSpacing: '-1.45px',
    lineHeight: '40px',
    fontWeight: 700,
  },
  '4': {
    fontSize: 4,
    letterSpacing: '-1.15px',
    lineHeight: '36px',
    fontWeight: 700,
  },
  '3': {
    fontSize: 3,
    letterSpacing: '-0.95px',
    lineHeight: '30px',
    fontWeight: 700,
  },
  '2b': {
    fontSize: 2,
    letterSpacing: '-0.75px',
    lineHeight: '26px',
    fontWeight: 700,
  },
  '2r': {
    fontSize: 2,
    letterSpacing: '-0.7px',
    lineHeight: '30px',
    fontWeight: 400,
  },
  '1b': {
    fontSize: 1,
    letterSpacing: '-0.65px',
    lineHeight: '24px',
    fontWeight: 700,
  },
  '1r': {
    fontSize: 1,
    letterSpacing: '-0.6px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  '-1r': {
    fontSize: -1,
    letterSpacing: '-0.45px',
    lineHeight: '22px',
    fontWeight: 400,
  },
  '-1b': {
    fontSize: -1,
    letterSpacing: '-0.4px',
    lineHeight: '22px',
    fontWeight: 700,
  },
  '-2r': {
    fontSize: -2,
    letterSpacing: '-0.4px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  '-2u': {
    fontSize: -2,
    letterSpacing: '0.2px',
    lineHeight: '20px',
    fontWeight: 500,
    textTransform: 'uppercase',
  },
};

type TextVariant =
  | '1r'
  | '1b'
  | '2r'
  | '2b'
  | '3'
  | 3
  | '4'
  | 4
  | '5'
  | 5
  | '6'
  | 6
  | '-1r'
  | '-1b'
  | '-2r'
  | '-2u';

type BaseTextProps = TextColorProps &
  TextAlignProps &
  TextShadowProps &
  TextStyleProps;

export type TextProps = React.HTMLAttributes<any> & {
  key?: any;
  as?: any;
  variant?: ResponsiveValue<TextVariant>;
  color?: ResponsiveValue<ThemeColors | null | undefined>;
  sx?: BaseTextProps &
    {
      [P in Pseudos]?: BaseTextProps;
    };
};

const Text = styled('span', { shouldForwardProp })<TextProps>(
  color,
  variant({
    variants: Object.entries(styles).reduce((acc, [k, v]) => {
      acc[k] = v;
      return acc;
    }, {}),
  }),
  ({ sx }) => {
    return sx ? css(sx) : null;
  },
);

Text.defaultProps = {
  variant: '1r',
};

Text.displayName = 'Monterey(Text)';

export { Text as default, styles };
